<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Formulärfält
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Standardiserade formulärkomponenter för admin-formulär. Alla tre wrappar
      shadcn Label ovanför fältet och emittar
      <span
        class="font-mono text-[13px] bg-[#f2f4f6] px-1.5 py-0.5 rounded-[5px]"
        >update:modelValue</span
      >
      för v-model-stöd.
    </p>

    <!-- Text input -->
    <PreviewFull label="Textfält — FormField">
      <div class="max-w-[440px]">
        <div class="my-5">
          <label
            class="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >Recepttitel</label
          >
          <input
            type="text"
            placeholder="t.ex. Surdegsbröd med frön"
            class="mt-2 flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring placeholder:text-muted-foreground"
          />
        </div>
      </div>
    </PreviewFull>

    <!-- Select -->
    <PreviewFull label="Listruta — FormSelect">
      <div class="max-w-[440px]">
        <div class="my-5">
          <label
            class="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >Svårighetsnivå</label
          >
          <select
            class="mt-2 flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
          >
            <option value="">Välj nivå…</option>
            <option value="enkel">Enkel</option>
            <option value="medel">Medel</option>
            <option value="avancerad">Avancerad</option>
          </select>
        </div>
      </div>
    </PreviewFull>

    <!-- Textarea -->
    <PreviewFull label="Textyta — FormTextarea">
      <div class="max-w-[440px]">
        <div class="my-5">
          <label
            class="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >Introduktion</label
          >
          <textarea
            placeholder="Beskriv receptet kort…"
            class="mt-2 flex min-h-[120px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
          ></textarea>
        </div>
      </div>
    </PreviewFull>

    <!-- FormErrors -->
    <PreviewFull label="Felmeddelanden — FormErrors">
      <div class="max-w-[440px]">
        <div
          class="bg-red-50 text-red-500 px-3 py-2 font-medium rounded-lg mb-4"
        >
          <h2 class="text-sm font-semibold mb-1">
            2 fel förhindrade att receptet sparades:
          </h2>
          <ul class="list-disc list-inside text-sm">
            <li>Titel kan inte vara tomt</li>
            <li>Ingredienser måste ha minst en rad</li>
          </ul>
        </div>
      </div>
    </PreviewFull>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import PreviewFull from "../components/PreviewFull.vue";
import CodeBlock from "../components/CodeBlock.vue";

const htmlCode = `<!-- Textfält -->
<FormField label="Recepttitel" name="recipe[title]" v-model="form.title" />

<!-- Listruta -->
<FormSelect label="Svårighetsnivå" name="recipe[difficulty]" v-model="form.difficulty">
  <option value="">Välj nivå…</option>
  <option value="enkel">Enkel</option>
  <option value="medel">Medel</option>
  <option value="avancerad">Avancerad</option>
</FormSelect>

<!-- Textyta -->
<FormTextarea label="Introduktion" name="recipe[ingress]" v-model="form.ingress" />

<!-- Felmeddelanden -->
<FormErrors :errors="errors" subject="recept" />`;

const cssCode = `/* Fält-wrapper: vertikal marginal 20px (my-5) */
/* Label: shadcn Label – 14px semibold */

/* Input / Select */
height: 36px;               /* h-9 */
border-radius: 6px;         /* rounded-md */
border: 1px solid var(--input);
padding: 4px 12px;          /* px-3 py-1 */
font-size: 16px;
box-shadow: 0 1px 2px rgba(0,0,0,0.05);   /* shadow-sm */
transition: border-color 150ms, box-shadow 150ms;
/* Focus: ring-1 ring-ring (teal) */

/* Textarea */
min-height: 192px;          /* min-h-48 */
padding: 8px 12px;          /* px-3 py-2 */

/* Felruta */
background: #fef2f2;        /* bg-red-50 */
color: #ef4444;             /* text-red-500 */
border-radius: 8px;         /* rounded-lg */
padding: 8px 12px;          /* px-3 py-2 */`;

const snippetTabs = [
  { label: "HTML", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
</script>
